import { getSchemaURL, getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { BIDDING_AND_PURCHASE_HISTORY } = ACCOUNT;

interface ProAccountPagesContext {
	selected_site_ids: number[] | null;
	total_site_count: number;
}

export const getProAccountPagesContext = (selectedSiteIds: number[] | null, totalSiteCount: number) => [
	{
		data: { selected_site_ids: selectedSiteIds, total_site_count: totalSiteCount } satisfies ProAccountPagesContext,
		schema: getSchemaURL(SNOWPLOW_EVENTS.PRO_ACCOUNT_PAGES),
	},
];

interface GroupStructureEventContext {
	selectedSiteIds: number[] | null;
	totalSiteCount: number;
}

export interface GroupStructurePurchasesEvents {
	onBannerViewed?: (data: GroupStructureEventContext) => void;
	onDealershipSelectionChanged?: (data: GroupStructureEventContext) => void;
	onViewDealershipsClicked?: (data: GroupStructureEventContext) => void;
}

export const triggerGroupStructureBannerViewedEvent = ({
	selectedSiteIds,
	totalSiteCount,
}: GroupStructureEventContext): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BIDDING_AND_PURCHASE_HISTORY,
		context: getProAccountPagesContext(selectedSiteIds, totalSiteCount),
		name: 'dlr_gs_banner_viewed',
		schemaName: SNOWPLOW_EVENTS.LOAD.SCHEMA,
		version: SNOWPLOW_EVENTS.LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerGroupStructureViewDealershipsClickedEvent = ({
	selectedSiteIds,
	totalSiteCount,
}: GroupStructureEventContext): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BIDDING_AND_PURCHASE_HISTORY,
		context: getProAccountPagesContext(selectedSiteIds, totalSiteCount),
		name: 'dlr_gs_view_dealerships_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerGroupStructureDealershipSelectionChangedEvent = ({
	selectedSiteIds,
	totalSiteCount,
}: GroupStructureEventContext): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BIDDING_AND_PURCHASE_HISTORY,
		context: getProAccountPagesContext(selectedSiteIds, totalSiteCount),
		name: 'dlr_gs_dealership_selection_changed',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerGroupStructureRestrictedMenuViewedEvent = ({
	selectedSiteIds,
	totalSiteCount,
}: GroupStructureEventContext): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BIDDING_AND_PURCHASE_HISTORY,
		context: getProAccountPagesContext(selectedSiteIds, totalSiteCount),
		name: 'dlr_gs_restricted_menu_viewed',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerGroupStructureContactNameViewedEvent = ({
	selectedSiteIds,
	totalSiteCount,
}: GroupStructureEventContext): void => {
	const eventPayload = getSnowplowEventPayload({
		category: BIDDING_AND_PURCHASE_HISTORY,
		context: getProAccountPagesContext(selectedSiteIds, totalSiteCount),
		name: 'dlr_gs_contact_name_viewed',
		schemaName: SNOWPLOW_EVENTS.LOAD.SCHEMA,
		version: SNOWPLOW_EVENTS.LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
